module.exports = "pegasus/assets/themelp1/small/24.png";